import gql from 'graphql-tag';
import { getContextTMC } from '@/utils/tmc';

const query = gql`
  query availableRoomsInfo(
    $checkin: String!
    $checkout: String!
    $hotelId: String!
    $corporationId: String
    $source: String
    $accountNumber: String
    $tripId: String
    $emailId: String
  ) {
    availableRoomsInfo(
      checkin: $checkin
      checkout: $checkout
      hotelId: $hotelId
      corporationId: $corporationId
      source: $source
      accountNumber: $accountNumber,
      tripId: $tripId,
      emailId: $emailId,
      tmc: "${getContextTMC()}"
    ) {
      availableRoomsInfo
      currency
      currencyName
    }
  }
`;

export default function availableRoomsInfo({
  apollo,
  checkin,
  checkout,
  hotelId,
  corporationId,
  userId,
  source,
  accountNumber,
  tripId,
  emailId
}) {
  return apollo.query({
    query,
    variables: {
      checkin,
      checkout,
      hotelId,
      corporationId,
      userId,
      source,
      accountNumber,
      getContextTMC,
      tripId,
      emailId
    }
  });
}
